import { getExtendedReport } from '../api/indicatorApi';
import { ExtendedReportFilters } from '../models/ExtendedReportFilters';
import { Filter } from '../components/MenuTabs/userTabsInterface';

export type IndicatorPayload = {
    regions?: number[];
    Filters?: Filter[];
    includeRegionalProjects?: number;
};

export async function fetchExtendedReportFromPayload(
    indicatorPayload: IndicatorPayload,
    overrides: Partial<ExtendedReportFilters> = {}
) {
    const filters: ExtendedReportFilters = {
        regions: indicatorPayload?.regions ?? [],
        discriminator: 'SupervisionPlanActivity',
        attributes: [],
        includeRegionalProjects: indicatorPayload?.includeRegionalProjects ?? 2,
        modReport: [0, 1, 2, 3, 4, 5, 6],
        baseFilters: indicatorPayload?.Filters ?? [],
        ...overrides,
    };

    const data = await getExtendedReport(filters);
    return data;
}
